import { createSelector } from 'reselect';

export const getSidebar = state => state.sidebar;
export const getShowSidebar = createSelector(getSidebar, sidebar => sidebar.showSidebar);



// WEBPACK FOOTER //
// ./src/store/sidebar/selectors.js